import { render, staticRenderFns } from "./Mecha65.vue?vue&type=template&id=3f0ec6b5&scoped=true"
import script from "./Mecha65.vue?vue&type=script&lang=ts"
export * from "./Mecha65.vue?vue&type=script&lang=ts"
import style0 from "./Mecha65.vue?vue&type=style&index=0&id=3f0ec6b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0ec6b5",
  null
  
)

export default component.exports